import { ApolloClient, InMemoryCache } from '@apollo/client'
import { vaultSubgraphEndpoint } from '~/constants/market'

const client = new ApolloClient({
  uri: vaultSubgraphEndpoint,
  cache: new InMemoryCache(),
})

export default client
